import { apiGet } from 'ApiPackage/MainModule/common/apiTools';
import { config } from 'CorePackage/MainModule/constants/config';

import { ICheckesDataRequest } from '../interfaces/ICheckesDataRequest';
import { ICheckesDataResponse } from '../interfaces/ICheckesDataResponse';
import { ICheckesPlansDataRequest } from '../interfaces/ICheckesPlansDataRequest';
import { IOpenDataResponse } from '../interfaces/IOpenDataResponse';

export async function getOpenData(isFederalLaw: boolean): Promise<IOpenDataResponse> {
  return apiGet<IOpenDataResponse>(`${config.server}/opendata/list?isFederalLaw248=${isFederalLaw}`);
}

export async function getCheckesData({
  year,
  monthId,
  isFederalLaw,
}: ICheckesDataRequest): Promise<ICheckesDataResponse> {
  return apiGet<ICheckesDataResponse>(`${config.server}/opendata/${year}/${monthId}?isFederalLaw248=${isFederalLaw}`);
}

export async function getCheckesPlansData({
  year,
  isFederalLaw,
}: ICheckesPlansDataRequest): Promise<ICheckesDataResponse> {
  return apiGet<ICheckesDataResponse>(`${config.server}/opendata/plans/${year}?isFederalLaw248=${isFederalLaw}`);
}
